import { PrismeLogger, PrismeConfig, LogApiTransporter } from "@bytel/logger-core";
class WebPrismeLogger extends PrismeLogger {
  constructor(config, autoInstrumentationCtx) {
    const prismeConfig = new PrismeConfig(config);
    super(
      prismeConfig,
      new LogApiTransporter(prismeConfig),
      autoInstrumentationCtx
    );
  }
}
export {
  WebPrismeLogger
};
//# sourceMappingURL=WebPrismeLogger.js.map
